<template>
  <div class="container">
    <b-row class="my-4 mt-28">
      <modal
        :show.sync="editModal"
        header-classes="pt-4 pb-0 px-6 text-white bg-primary"
        hide-footer
        footerClasses="hidden"
        body-classes="md:p-6 lg:p-6 p-3"
      >
        <h6
          slot="header"
          class="md:text-2xl lg:text-2xl text-xl font-semibold pt-1 text-white"
        >
          Communities
        </h6>
        <div class="mb-2">
          <b-form-input
            v-model="text"
            placeholder="Enter community name"
            @input="searches"
            size="sm"
          ></b-form-input>
        </div>
        <AllChannelList />
      </modal>
      <!-- <Create-Post-Sidebar /> -->
      <!-- :isSidebarActive="openCreatePostSidebar"
        @closeSidebar="toggleCreatePostSidebar" -->
      <Add-Channel-Sidebar />
      <!-- :isSidebarActive="openAddChannelSidebar"
        @closeSidebar="toggleAddChannelSidebar" -->
      <div class="flex w-full">
        <b-col
          cols="12"
          md="3"
          class="lg:pr-4 md:pr-4 pr-0 0 lg:pl-2 md:pl-2 pl-0"
          v-if="ChannelList.length"
        >
          <div class="w-full lg:px-0 md:px-0 px-4">
            <b-card
              class="rounded-xl bgD9F3F6 mb-4 relative md:px-3 lg:px-3 px-0"
            >
              <div class="absolute right-0 bottom-0">
                <img src="./img/chnl-lft-bg.svg" alt="BGSvg" />
              </div>

              <div class="absolute top-8 left-4">
                <img src="./img/Ellipse 17.svg" alt="BGSvg" />
              </div>

              <div class="absolute left-0 bottom-0">
                <img src="./img/Ellipse 18.svg" alt="BGSvg" />
              </div>

              <NewChannel />
            </b-card>
            <!-- <b-card class="rounded-xl bgD9F3F6 mb-4 px-3">
          
          <NewChannel @create-channel="createChannel" />
        </b-card> -->
            <!-- <div class="flex justify-between items-center pl-2 ">
          <h2 class="font-bold text-2xl">Channel</h2>
          <b-navbar-nav>
            <b-button
              @click="createPost"
              class="text-sm bg-primary text-white font-semibold h-40PX py-1 px-2 "
            >
              Create Post</b-button
            >
          </b-navbar-nav>
        </div> -->
            <!-- <ChannelSearch /> -->
            <!-- <ChannelList /> -->
            <!-- <NewChannel @create-channel="createChannel" /> -->

            <b-card
              class="rounded-xl cust-pd-lft-cb mb-4"
              v-if="ChannelList.length"
            >
              <div class="flex justify-between items-center pb-2 px-2">
                <p class="chnl-left-ttl clr777">Your Communities</p>
                <p class="chnl-left-ttl clr777">({{ ChannelList.length }})</p>
                <!-- <base-button
                type="primary"
                outline
                size="sm"
                class="flex items-center cursor-pointer rounded-sm"
                @click="editModal = true"
              >
                <img
                  src="./img/ic_round-travel-explore.svg"
                  alt="SearchIcon"
                  class="h-5"
                />
                <i class="fas fa-search-plus"></i>
                <span class="font-bold">Join</span>
              </base-button> -->
              </div>
              <ChannelLists />
            </b-card>
            <b-card class="rounded-xl cust-pd-lft-cb cust-overflow-y5 h-38rem">
              <div class="flex justify-between items-center pb-2">
                <p class="chnl-left-ttl clr777">Other Channels</p>
                <p class="chnl-left-ttl clr777">
                  ({{ channels.length - ChannelList.length }})
                </p>
              </div>
              <AllChannelList />
            </b-card>
          </div>
        </b-col>

        <b-col
          cols="12"
          :md="ChannelList.length == 0 ? '12' : '6'"
          class="px-0 cust-overflow-y lg:mt-0 md:mt-0 mt-4"
        >
          <!-- <PostFilter /> -->
          <div class="" v-if="ChannelList.length >= 1">
            <Feed />
          </div>

          <!-- <NoData /> -->

          <!-- no channel condition -->
          <div class="" v-if="ChannelList.length == 0">
            <img src="./img/newcommunity.png" alt="" class="h-80 mx-auto" />
            <p class="mt-6 text-xl font-semibold text-center">
              Lets get started!
            </p>
            <p class="mt- text-lg font-semibold text-center">
              Start your activity by creating first channel or joining or any
              existing channel
            </p>
            <div class="flex mx-auto justify-center mt-6">
              <!--<b-button variant="primary" class="mr-4" @click="createChannel"
              >New channel</b-button
            >-->

              <b-button
                variant="outline-primary"
                class="ml-4"
                @click="editModal = true"
                >Join channel</b-button
              >
            </div>
          </div>
        </b-col>
        <b-card class="mx-4 w-full">
          <b-col
            cols="12"
            class="h-83vh lg:pr-0 md:pr-2 pr-0 lg:pl-0 md:pl-4 pl-0 md:mt-0 lg:mt-0 mt-6 cust-cardbodycard"
            v-if="ChannelList.length > 0"
          >
            <div
              class="rounded-xl lg:px-0 md:px-0 px-4"
              v-if="Object.keys(channel).length"
            >
              <ChannelInfo />
              <ChannelMembers />
            </div>
          </b-col>
        </b-card>
      </div>
    </b-row>
  </div>
</template>

<script>
import "./scss/index.scss";

import AddChannelSidebar from "./components/AddChannelSidebar";
import ChannelSearch from "./components/ChannelSearch";
import ChannelList from "./components/ChannelList";
import ChannelLists from "./components/ChannelLists";
import NewChannel from "./components/NewChannel.vue";
import AllChannelList from "./components/AllChannelList.vue";
import PostFilter from "./components/PostFilter.vue";
import Feed from "./components/Feed";

import NoData from "./components/NoData.vue";
import ChannelInfo from "./components/ChannelInfo";
import ChannelMembers from "./components/ChannelMembers";
import CreatePostSidebar from "@/layout/main/components/navbar/components/CreatePostSidebar";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    AddChannelSidebar,
    ChannelSearch,
    ChannelList,
    NewChannel,
    PostFilter,
    Feed,
    ChannelInfo,
    ChannelMembers,
    ChannelLists,
    CreatePostSidebar,
    NoData,
    AllChannelList,
  },
  data() {
    return {
      text: "",
      // openCreatePostSidebar: false,
      // openAddChannelSidebar: false,
      editModal: false,
    };
  },
  methods: {
    createChannel() {
      // this.toggleAddChannelSidebar(true);
      // this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", true);
    },
    toggleAddChannelSidebar(val = false) {
      this.openAddChannelSidebar = val;
    },
    async createPost() {
      this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
    },
    async toggleCreatePostSidebar(val = false) {
      this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", val);
    },
    async getUserChannel() {
      try {
        let data = await this.$store.dispatch("channel/GetALLChannel", {});
      } catch (error) {
        if (error.response.data.code == 401) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    searches() {
      this.$store.commit("channel/search", this.text);
    },
  },
  computed: {
    ...mapGetters("channel", {
      ChannelList: "currentUserChannel",
    }),
    ...mapState("channel", {
      channel: "selectedChannel",
    }),
    ...mapState("channel", {
      channels: "channels",
    }),
    ...mapState("posts", {
      posts: "posts",
    }),

    ...mapState("auth", {
      user: "user",
      getUserByUserId: "getUserByUserId",
    }),
  },
  async mounted() {
    this.$store.dispatch("posts/getChannelPosts", this.channel._id);
    this.getUserChannel();
    await this.$store.dispatch("auth/getUserByUserId", {
      userId: this.user._id,
    });
  },
  created() {},
};
</script>
<style>
.custheader .modal-header {
  background: #4f0a4b;
}
</style>
